import { authGet } from './authMiddleware';

export const getPropertyAutocomplete = async (query) => {
    return authGet(`/api/Property/AutoComplete?PropertyName=${query}`);
}